import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'SubContractor';

const routes = [
    {
        matchRegex: '/SubContractor',
        name: getRouteName(MODULE_NAME, 'SubContractor'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_SECTION_SUMMARY,
        ],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
                {
                    key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS',
                    label: 'Trigger Fetch List Successfully',
                },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_ADDITION_MENU]: [
                {
                    key: 'tab-primary',
                    label: 'Tab Subcontractors',
                },
                {
                    key: 'tab-template',
                    label: 'Tab Subcontractor Template',
                },
            ],
            [SLOT_KEY.SLOT_SECTION]: [
                {
                    key: 'main-tab-list-container-relation',
                    label: 'Main Tab List Container Relation',
                },
            ],
            [SLOT_KEY.SLOT_SECTION_SUMMARY]: [
                { key: 'detail-tab', label: 'Detail Tab' },
            ],
        },
    },

    {
        matchRegex: '/Subcontractor/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Subcontractor Detail'),
        slots: [
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                {
                    key: 'wrapper-section-details',
                    label: 'Tab Details - Wrapper Section',
                },
                {
                    key: 'wrapper-section-document',
                    label: 'Tab Documents - Wrapper Section',
                },
                {
                    key: 'wrapper-section-contacts',
                    label: 'Tab Contacts - Wrapper Section',
                },
                {
                    key: 'wrapper-section-warning-notes',
                    label: 'Tab Warning Notices - Wrapper Section',
                },
                {
                    key: 'wrapper-section-sor',
                    label: 'Tab Assigned SOR Libraries - Wrapper Section',
                },
            ],
            [SLOT_KEY.SLOT_V_FORM_SECTION]: [
                { key: 'notes-tab', label: 'Tab Notes - Wrapper form' },
            ]
        },
    },

    {
        matchRegex: '/SubContractorPO',
        name: getRouteName(MODULE_NAME, 'Subcontractor PO'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SCRIPTS
        ],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [

                { key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'page-title-action', label: 'Section Page Action' },
            ],
        },
    },

    {
        matchRegex: '/SubContractorPO/Create',
        name: getRouteName(MODULE_NAME, 'Subcontractor PO Create'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_SECTION_SUMMARY,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION_SUMMARY]: [
                { key: 'create-sub-po-tab', label: 'Detail Tab - SubcontractorPO Create' },
            ],
        }
    },

    {
        matchRegex: '/SubcontractorPO/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Subcontractor PO Detail'),
        slots: [
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SECTION_SUMMARY
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_FORM_SECTION]: [
                { key: 'notes-tab', label: 'Tab Notes - Wrapper form' },
            ],
            [SLOT_KEY.SLOT_SECTION]: [
                {
                    key: 'wrapper-section-details',
                    label: 'Tab Details - Wrapper Section',
                },
                {
                    key: 'subcontractor-po-items-section-action',
                    label: 'Tab Items - Wrapper Section Action',
                },
                {
                    key: 'invoices-section-action',
                    label: 'Tab Subcontractor Invoices - Wrapper Section Action',
                },
                {
                    key: 'wrapper-section-outbound-email',
                    label: 'Tab Outbound Emails - Wrapper Section',
                },
            ],
            [SLOT_KEY.SLOT_SECTION_SUMMARY]: [
                { key: 'detail-tab', label: 'Detail Tab - SubcontractorPO Detail' },
            ],
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'wrapper-section-audit', label: 'Tab History Audit - Wrapper section' },
            ],
        },
    },
    {
        matchRegex: '/SubContractorPO/SubContractorInvoiceDetail/:id',
        name: getRouteName(MODULE_NAME, 'SubContractor Invoice Detail'),
        slots: [
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-line-list', label: 'Invoice Line List' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' },
            ],
        },
    },
]

export default routes;